import request from '@/utils/request'

// 通过类型查询关于我们数据 type:1.品牌文化 2.品牌优势 3.荣誉资质 4.品牌历程 5.自研实力
export function getAboutUsListByType(query) {
  return request({
    url: '/api/aboutUs/getAboutUsListByType',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/aboutUs.js